import React, { useEffect } from 'react';

const EditableField = ({
    tierIndex,
    dataSetIndex,
    fieldPath,
    value,
    className = "",
    isNumeric = false,
    isMoney = false, // NEW
    editingField,
    editValue,
    setEditValue,
    onStartEdit,
    onSave,
    onCancel,
    disabled = false
}) => {
    const fieldKey = `${tierIndex}-${dataSetIndex}-${fieldPath}`;
    const isEditing = editingField === fieldKey;

    // Ensure numeric values always have 2 decimals when editing
    useEffect(() => {
        if (isEditing && isNumeric && editValue !== "") {
            const num = Number(editValue);
            if (!isNaN(num)) {
                setEditValue(num.toFixed(2));
            }
        }
    }, [isEditing]);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSave();
        } else if (e.key === 'Escape') {
            onCancel();
        }
    };

    if (isEditing) {
        return (
            <div className="flex items-center gap-1">
                <input
                    type="text" // keep as text to preserve trailing zeros
                    value={editValue}
                    onChange={(e) => {
                        let val = e.target.value;
                        if (isNumeric) {
                            if (/^\d*\.?\d*$/.test(val)) {
                                setEditValue(val);
                            }
                        } else {
                            setEditValue(val);
                        }
                    }}
                    onKeyDown={handleKeyPress}
                    onBlur={() => {
                        if (isNumeric && editValue !== "") {
                            const num = Number(editValue);
                            if (!isNaN(num)) {
                                setEditValue(num.toFixed(2));
                            }
                        }
                        onSave();
                    }}
                    className="border border-blue-300 rounded px-1 py-0.5 text-sm w-full min-w-0 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    autoFocus
                />
                <button
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={onSave}
                    className="text-green-600 hover:text-green-800 text-xs p-0.5"
                    title="Save"
                >
                    ✓
                </button>
                <button
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={onCancel}
                    className="text-red-600 hover:text-red-800 text-xs p-0.5"
                    title="Cancel"
                >
                    ✕
                </button>
            </div>
        );
    }

    // ---- Display mode ----
    let displayValue = value;
    if (isNumeric && value !== undefined && value !== null) {
        const num = Number(value);
        if (isMoney) {
            displayValue = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
            }).format(num);
        } else {
            displayValue = num.toFixed(2);
        }
    }

    return (
        <span
            className={`${className} ${!disabled ? 'cursor-pointer hover:bg-gray-100 rounded px-1' : ''}`}
            onClick={() => !disabled && onStartEdit(tierIndex, dataSetIndex, fieldPath)}
            title={!disabled ? "Click to edit" : "Editing disabled during comparison"}
        >
            {displayValue || '—'}
        </span>
    );
};

export default EditableField;
